import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RouterService } from './router.service';
import { User, UserSettings } from '../types/users/User';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private url = this.router.getApiUrl('users', true);

    constructor(
        private http: HttpClient,
        private router: RouterService,
    ) {}

    /**
     * Gets all LAS users.
     */
    getAll(): Observable<User[]> {
        return this.http.get<User[]>(`${this.url}/${Endpoints.All}`);
    }

    /**
     * Gets all active LAS users.
     */
    getAllActive(): Observable<User[]> {
        return this.http.get<User[]>(`${this.url}/${Endpoints.Active}`);
    }

    /**
     * Get a user by id.
     * @param id The id of the user.
     */
    getById(id: number): Observable<User> {
        return this.http.get<User>(`${this.url}/${id}`);
    }

    /**
     * Save the user's settings.
     * @param settings The user's settings.
     */
    saveSettings(settings: UserSettings) {
        return this.http.post<UserSettings>(
            `${this.url}/${Endpoints.Settings}`,
            settings,
        );
    }

    /**
     * Gets the user's settings by loading the full LAS user.
     */
    getUserSettings() {
        const url = this.router.getApiUrl('user', true);
        return this.http.get<User>(url).pipe(map((user) => user.settings));
    }
}

enum Endpoints {
    All = 'All',
    Active = 'allactive',
    Impersonation = 'Impersonation',
    Settings = 'Settings',
}
